import React from "react";
import Icon from '@ant-design/icons';
import { ReactComponent as MessageSvg } from './VisualizationCapacitySVG.svg';

const IconVisualizationCapacity = (props) => {
  return (<Icon component={MessageSvg} {...props} />);
}

export default IconVisualizationCapacity;